(function () {
  const BACKEND_URL = "https://chat-bot-liart-three.vercel.app/api/chat";
  const COLORS = {
    ink: "#0A0A0A",
    white: "#FFFFFF",
    paper: "#F3F3F3",
    muted: "#767676",
  };

  const LOGO_DATA_URI =
    "data:image/png;base64,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";

  let sessionId = sessionStorage.getItem("fh_chat_session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("fh_chat_session_id", sessionId);
  }
  let customerEmail = sessionStorage.getItem("fh_chat_email") || null;
  let awaitingEmail = false;
  let pendingMessage = null;

  const MAX_HISTORY = 20;
  let conversationHistory = [];

  function pushHistory(role, content) {
    conversationHistory.push({ role, content });
    if (conversationHistory.length > MAX_HISTORY) {
      conversationHistory = conversationHistory.slice(-MAX_HISTORY);
    }
  }

  const style = document.createElement("style");
  style.textContent = `
    .fh-chat-bubble {
      position: fixed; bottom: 20px; right: 20px; z-index: 999999;
      width: 62px; height: 62px; border-radius: 50%;
      background: ${COLORS.ink}; color: ${COLORS.white};
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; border: 2.5px solid ${COLORS.ink};
      box-shadow: 0 6px 0 ${COLORS.ink}, 0 6px 20px rgba(0,0,0,0.2);
      transition: transform 0.25s cubic-bezier(.34,1.56,.64,1);
      font-family: var(--font-body-family, "Inter", Arial, sans-serif);
    }
    .fh-chat-bubble:hover { transform: rotate(-8deg) scale(1.08); }
    .fh-chat-bubble:active { transform: scale(0.94); }
    .fh-chat-bubble.fh-hide { display: none; }

    .fh-chat-window {
      position: fixed; top: 0; right: 0; bottom: 0; z-index: 999999;
      height: 100vh; width: 400px; max-width: 100vw;
      background: ${COLORS.white};
      border: 2.5px solid ${COLORS.ink}; border-right: none;
      border-radius: 12px 0 0 12px;
      box-shadow: -4px 0 24px rgba(0,0,0,0.15);
      display: none; flex-direction: column; overflow: hidden;
      font-family: var(--font-body-family, "Inter", Arial, sans-serif);
      transform: translateX(24px); opacity: 0;
      transition: transform 0.3s cubic-bezier(.34,1.56,.64,1), opacity 0.2s ease;
    }
    .fh-chat-window.fh-open {
      display: flex; transform: translateX(0); opacity: 1;
    }
    @media (max-width: 500px) {
      .fh-chat-window { width: 100vw; border-radius: 0; border-right: 2.5px solid ${COLORS.ink}; }
    }

    .fh-chat-header {
      background: ${COLORS.ink}; color: ${COLORS.white};
      padding: 18px 18px 16px; display: flex; flex-direction: column;
      align-items: center; justify-content: center; position: relative;
      border-bottom: 2.5px solid ${COLORS.ink};
    }
    .fh-chat-header-icon {
      width: 64px; height: 64px; border-radius: 50%;
      border: 3px solid ${COLORS.white}; display: block;
      object-fit: cover;
    }
    .fh-chat-header-name {
      margin-top: 6px; font-size: 19.5px; font-weight: 800;
      line-height: 1.1; letter-spacing: 1px; text-transform: uppercase;
      color: ${COLORS.white};
    }
    .fh-chat-header-actions {
      position: absolute; top: 14px; right: 14px;
      display: flex; align-items: center;
    }
    .fh-chat-close {
      background: ${COLORS.white}; color: ${COLORS.ink}; border: 2px solid ${COLORS.white};
      border-radius: 50%; width: 44px; height: 44px;
      font-size: 26px; cursor: pointer; line-height: 1;
      display: flex; align-items: center; justify-content: center;
      font-weight: 700; transition: transform 0.15s ease;
    }
    .fh-chat-close:hover { transform: scale(1.1) rotate(90deg); }

    .fh-chat-messages {
      flex: 1; overflow-y: auto; padding: 16px;
      background: ${COLORS.paper};
      display: flex; flex-direction: column; gap: 10px;
    }
    .fh-msg {
      max-width: 84%; padding: 11px 14px; font-size: 13.5px;
      line-height: 1.5; white-space: pre-wrap; font-weight: 500;
      overflow-wrap: anywhere; word-break: break-word;
    }
    .fh-msg-bot {
      background: ${COLORS.white}; color: ${COLORS.ink};
      align-self: flex-start; border: 2px solid ${COLORS.ink};
      border-radius: 12px 12px 12px 3px;
    }
    .fh-msg-user {
      background: ${COLORS.ink}; color: ${COLORS.white};
      align-self: flex-end; border-radius: 12px 12px 3px 12px;
    }
    .fh-msg-typing { color: ${COLORS.muted}; font-style: italic; border-style: dashed; }

    .fh-chat-starters {
      display: flex; flex-direction: column; gap: 8px;
      align-self: flex-start; max-width: 92%;
    }
    .fh-chat-starter {
      background: ${COLORS.white}; color: ${COLORS.ink};
      border: 2px solid ${COLORS.ink}; border-radius: 999px;
      padding: 9px 16px; font-size: 13px; font-weight: 600;
      cursor: pointer; text-align: left; font-family: inherit;
      transition: background 0.15s ease;
    }
    .fh-chat-starter:hover { background: #e9e9e9; }

    .fh-chat-input-area {
      border-top: 2.5px solid ${COLORS.ink};
      background: ${COLORS.white};
      padding: 12px 12px 10px;
    }
    .fh-chat-input-row {
      display: flex; gap: 8px; align-items: center;
    }
    .fh-chat-input {
      flex: 1; border: 2px solid ${COLORS.ink}; border-radius: 4px;
      padding: 10px 15px; font-size: 16px; outline: none;
      font-family: inherit; font-weight: 500; color: ${COLORS.ink};
    }
    .fh-chat-input::placeholder { color: ${COLORS.muted}; }
    .fh-chat-input:focus { box-shadow: 3px 3px 0 ${COLORS.ink}; }
    .fh-chat-send {
      background: ${COLORS.ink}; color: ${COLORS.white}; border: 2px solid ${COLORS.ink};
      border-radius: 50%; width: 40px; height: 40px; flex-shrink: 0;
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      transition: transform 0.12s ease;
    }
    .fh-chat-send svg { width: 17px; height: 17px; }
    .fh-chat-send:active { transform: scale(0.94); }
    .fh-chat-send:disabled { opacity: 0.4; cursor: default; }

    .fh-chat-charcount {
      text-align: right; font-size: 11px; color: ${COLORS.muted};
      margin-top: 4px; padding-right: 2px;
    }
    .fh-chat-disclaimer {
      text-align: center; font-size: 11px; color: ${COLORS.muted};
      margin-top: 6px; line-height: 1.4;
    }

    @media (prefers-reduced-motion: reduce) {
      .fh-chat-bubble, .fh-chat-window, .fh-chat-close, .fh-chat-send { transition: none; }
    }
  `;
  document.head.appendChild(style);

  const bubble = document.createElement("button");
  bubble.className = "fh-chat-bubble";
  bubble.setAttribute("aria-label", "Open chat support");
  bubble.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0618/4324/3069/files/Asset_41_3.svg?v=1784730327"
         alt="For Hair" style="width: 28px; height: 28px; filter: brightness(0) invert(1);" />
  `;

  const STARTER_QUESTIONS = [
    "Where is my order?",
    "What makes FOR CURLS different?",
    "What's your shipping and return policy?",
  ];
  const GREETING =
    "Hi! I'm here to help with order status or questions about our products. What can I help with?";
  const INPUT_MAXLENGTH = 500;

  const win = document.createElement("div");
  win.className = "fh-chat-window";
  win.innerHTML = `
    <div class="fh-chat-header">
      <img class="fh-chat-header-icon"
        src="/cdn/shop/t/8/assets/chat-widget-profile-pic.png"
        alt="For Hair" />
      <div class="fh-chat-header-name">For Hair</div>
      <div class="fh-chat-header-actions">
        <button class="fh-chat-close" aria-label="Close chat">&times;</button>
      </div>
    </div>
    <div class="fh-chat-messages" id="fh-messages"></div>
    <div class="fh-chat-input-area">
      <div class="fh-chat-input-row">
        <input class="fh-chat-input" id="fh-input" type="text" maxlength="${INPUT_MAXLENGTH}"
          placeholder="Ask about your order or a product..." />
        <button class="fh-chat-send" id="fh-send" aria-label="Send message">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 12L20 4L13 20L11 13L4 12Z"/>
          </svg>
        </button>
      </div>
      <div class="fh-chat-charcount" id="fh-charcount">0 / ${INPUT_MAXLENGTH}</div>
      <div class="fh-chat-disclaimer">This assistant is powered by AI, so mistakes are possible.</div>
    </div>
  `;

  document.body.appendChild(bubble);
  document.body.appendChild(win);

  const messagesEl = win.querySelector("#fh-messages");
  const inputEl = win.querySelector("#fh-input");
  const sendBtn = win.querySelector("#fh-send");
  const closeBtn = win.querySelector(".fh-chat-close");
  const charcountEl = win.querySelector("#fh-charcount");

  function addMessage(text, sender) {
    const el = document.createElement("div");
    el.className = "fh-msg " + (sender === "user" ? "fh-msg-user" : "fh-msg-bot");
    el.textContent = text;
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return el;
  }

  function addTypingIndicator() {
    const el = document.createElement("div");
    el.className = "fh-msg fh-msg-bot fh-msg-typing";
    el.textContent = "Typing...";
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return el;
  }

  let startersEl = null;
  function showStarters() {
    hideStarters();
    startersEl = document.createElement("div");
    startersEl.className = "fh-chat-starters";
    STARTER_QUESTIONS.forEach((question) => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "fh-chat-starter";
      chip.textContent = question;
      chip.addEventListener("click", () => {
        if (chip.disabled) return;
        inputEl.value = question;
        handleSend();
      });
      startersEl.appendChild(chip);
    });
    messagesEl.appendChild(startersEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideStarters() {
    if (startersEl) {
      startersEl.remove();
      startersEl = null;
    }
  }

  function updateCharCount() {
    charcountEl.textContent = inputEl.value.length + " / " + INPUT_MAXLENGTH;
  }
  inputEl.addEventListener("input", updateCharCount);

  let greeted = false;
  function openWindow() {
    win.classList.add("fh-open");
    bubble.classList.add("fh-hide");
    if (!greeted) {
      greeted = true;
      addMessage(GREETING, "bot");
      showStarters();
    }
  }

  function closeWindow() {
    win.classList.remove("fh-open");
    bubble.classList.remove("fh-hide");
  }

  function startNewConversation() {
    conversationHistory = [];
    customerEmail = null;
    awaitingEmail = false;
    pendingMessage = null;
    sessionStorage.removeItem("fh_chat_email");
    messagesEl.innerHTML = "";
    startersEl = null;
    inputEl.value = "";
    updateCharCount();
    addMessage(GREETING, "bot");
    showStarters();
    inputEl.focus();
  }

  bubble.addEventListener("click", openWindow);
  closeBtn.addEventListener("click", closeWindow);

  async function sendToBackend(message, email) {
    const res = await fetch(BACKEND_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message,
        sessionId,
        email: email || undefined,
        history: conversationHistory,
      }),
    });
    if (!res.ok) throw new Error("Request failed: " + res.status);
    return res.json();
  }

  async function handleSend() {
    const text = inputEl.value.trim();
    if (!text) return;

    hideStarters();
    inputEl.value = "";
    updateCharCount();
    sendBtn.disabled = true;
    addMessage(text, "user");

    // Scan every message for an email, not just while awaitingEmail — a
    // customer might volunteer it unprompted mid-sentence, or provide a
    // new one later to retry a failed lookup. Always overwrite with the
    // latest match so a newer email takes priority over a stale one.
    const emailMatch = text.match(/[^\s]+@[^\s]+\.[^\s]+/);
    if (emailMatch) {
      customerEmail = emailMatch[0];
      sessionStorage.setItem("fh_chat_email", customerEmail);
    }

    if (awaitingEmail) {
      awaitingEmail = false;

      if (emailMatch) {
        const question = pendingMessage;
        pendingMessage = null;

        const typing = addTypingIndicator();
        try {
          const data = await sendToBackend(question, customerEmail);
          typing.remove();
          addMessage(data.reply, "bot");
          pushHistory("user", text);
          pushHistory("assistant", data.reply);
        } catch (err) {
          typing.remove();
          addMessage(
            "Sorry, something went wrong on my end. Please try again in a moment.",
            "bot"
          );
        }
        sendBtn.disabled = false;
        inputEl.focus();
        return;
      }

      // Not an email — don't loop asking again. Treat this as a new
      // message and let Claude's own reply handle it.
      pendingMessage = null;
    }

    const typing = addTypingIndicator();
    try {
      const data = await sendToBackend(text, customerEmail);
      typing.remove();
      addMessage(data.reply, "bot");
      pushHistory("user", text);
      pushHistory("assistant", data.reply);

      if (data.needsEmail) {
        awaitingEmail = true;
        pendingMessage = text;
      }
    } catch (err) {
      typing.remove();
      addMessage(
        "Sorry, something went wrong on my end. Please try again in a moment.",
        "bot"
      );
    }
    sendBtn.disabled = false;
    inputEl.focus();
  }

  sendBtn.addEventListener("click", handleSend);
  inputEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter") handleSend();
  });
})();
